import { Avatar, Menu, MenuButton, MenuGroup, MenuItem, MenuList } from '@chakra-ui/react'
import { useRouter } from '@tanstack/react-router'

import { useUser } from '@queries/useUser'

export function User() {
    const { userData, logout } = useUser()
    const router = useRouter()

    return (
        <Menu>
            <MenuButton>
                <Avatar name={userData?.email} />
            </MenuButton>
            <MenuList>
                <MenuGroup title="Profile">
                    <MenuItem onClick={() => router.navigate({ to: '/settings' })}>Settings</MenuItem>
                    <MenuItem onClick={() => logout()}>Log out</MenuItem>
                </MenuGroup>
            </MenuList>
        </Menu>
    )
}
